import styled from 'styled-components';

export var ErrorBoundaryWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: var(--gap-primary);

	p {
		padding: 8px;
	}
`;
